import { useMemo, useReducer } from 'react';
import type { FunctionComponent, ReactNode } from 'react';

import OrdersContext from './OrdersContext';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';

const OrdersProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return <OrdersContext.Provider value={{ actions, state }}>{children}</OrdersContext.Provider>;
};

export default OrdersProvider;
